import { Button, Card, Input, TableProps } from "antd";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import PayrollImportOutlined from "../../../../assets/icons/PayrollImportOutlined";
import SearchIcon from "../../../../assets/icons/SearchIcon";
import ViewIcon from "../../../../assets/icons/ViewIcon";
import CustomTable from "../../../../components/ui/CustomTable";
import { useGetAllBatchVendorQuery } from "../../../../features/portal/batch/batchApi";
import useError from "../../../../hooks/useError";
import useModal from "../../../../hooks/useModal";
import useTable from "../../../../hooks/useTable";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { formatDate, formatTime } from "../../../../lib/time";
import {
  GetAllBatchDataParamsType,
  GetAllBatchDataType,
} from "../../../../types/portal/batch";
import { countParPageSerialNumber } from "../../../../utils/number";
import { addKeyInArray } from "../../../../utils/utils";
import PaymentSalaryVendorModal from "../Payments/PaymentSalaryVendorModal";

export default function BatchVendorV2() {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const {
    page,
    limit,
    handlePagination,
    handleFilter,
    handleLimit,
    filter,
    keyword,
    handleSearch,
  } = useTable<GetAllBatchDataParamsType>();

  const { open, handleOpen, handleClose } = useModal<
    undefined,
    "CONFIRM_FOR_APPROVAL"
  >(reRender);
  const roleCheck = localStorage.getItem("project_role");
  const projectId = localStorage.getItem("product_id");
  const { user } = useAppSelector((state) => state.auth);

  const { isError, error, isLoading, data, refetch } =
    useGetAllBatchVendorQuery({
      params: {
        ...filter,
        skip: undefined,
        search: keyword,
        company_id: user?.data?.company_id,
        projectId: Number(projectId),
        page,
      },
    });
  useError(isError, error, "Get all batch fail");

  function reRender() {
    refetch();
  }

  const columns: TableProps<GetAllBatchDataType>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: <div className="whitespace-nowrap !w-[120px]">Batch Name</div>,
      dataIndex: "batchName",
      render: (val) => (val ? val : "N/A"),
    },
    {
      title: <span className="whitespace-nowrap">Import Date</span>,
      dataIndex: "created_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span className="whitespace-nowrap">Number of Employees</span>,
      align: "center",
      dataIndex: "numberOfEmployees",
      render: (val) => (val ? val : 0),
    },
    {
      title: <span className="whitespace-nowrap">Amount (BDT)</span>,
      align: "center",
      dataIndex: "totalAmount",
      render: (val: string | number) => (
        <>৳ {val ? Number(val).toFixed(2) : 0}</>
      ),
    },
    {
      title: <span className="whitespace-nowrap">Disbursed Amount (BDT)</span>,
      align: "center",
      dataIndex: "totalDisbursed",
      render: (val: string | number) => (
        <>৳ {val ? Number(val).toFixed(2) : 0}</>
      ),
    },
    {
      title: <span className="whitespace-nowrap">Pending Amount (BDT)</span>,
      align: "center",
      dataIndex: "totalPending",
      render: (val: string | number) => (
        <>৳ {val ? Number(val).toFixed(2) : 0}</>
      ),
    },
    {
      title: <span className="whitespace-nowrap">Disbursement Type</span>,
      align: "center",
      dataIndex: "disbursement_type",
      render: (val: string) =>
        val ? val.charAt(0).toUpperCase() + val.slice(1).toLowerCase() : "N/A",
    },
    {
      title: <span className="whitespace-nowrap">Created At</span>,
      align: "center",
      dataIndex: "created_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <span className="whitespace-nowrap">Updated At</span>,
      align: "center",
      dataIndex: "updated_at",
      render: (val: string) =>
        val ? (
          <>
            {formatDate(val)}, {formatTime(val)}
          </>
        ) : (
          "N/A"
        ),
    },
    {
      title: <div className="whitespace-nowrap !w-[110px]">Status</div>,
      dataIndex: "batch_status",
      align: "center",
      render: (val) => (
        <span
          className={`px-2 py-1 rounded text-xs font-medium ${
            val === "completed"
              ? "bg-green-100 text-green-700"
              : "bg-yellow-100 text-yellow-700"
          }`}
        >
          {val.charAt(0).toUpperCase() + val.slice(1)}
        </span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val, record: any) => (
        <div className="flex justify-center items-center gap-2">
          <Link to={`/admin/vendor-payment/batch/payments/${val}`}>
            <Button
              className="action-button !w-[80px] disabled:!bg-[#ddd]"
              size="small"
              icon={<ViewIcon />}
              //   disabled={
              //     record?.status === "checker" && roleCheck === "Approver"
              //   }
            >
              Open
            </Button>
          </Link>
        </div>
      ),
    },
  ];

  return (
    <>
      {open?.type === "IMPORT" && (
        <PaymentSalaryVendorModal open={open.open} handleClose={handleClose} />
      )}

      <SidebarLayout title="Batch Details">
        <Card className="mb-4">
          <p className="text-blue-500 text-2xl font-medium leading-tight flex items-center gap-3">
            <div>Role: {roleCheck}</div>
          </p>
        </Card>
        <CustomTable
          loading={isLoading}
          limit={limit}
          page={page}
          columns={columns}
          total={data?.data?.total}
          dataSource={addKeyInArray(data?.data?.data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          //   rowSelection={{
          //     type: "checkbox",
          //     selectedRowKeys: selectedData,
          //     onChange: (key) => {
          //       setSelectedData(key as string[]);
          //     },
          //     getCheckboxProps: (record) => {
          //       return {
          //         disabled: record?.status === "invited",
          //       };
          //     },
          //     columnWidth: 40,
          //   }}
          filterSection={
            <>
              <Input
                suffix={<SearchIcon />}
                placeholder="Batch Name"
                style={{ width: 205 }}
                allowClear
                onChange={handleSearch}
              />

              {roleCheck === "Maker" && (
                <Button
                  onClick={() => handleOpen({ type: "IMPORT" })}
                  type="default"
                  className="h-9 px-3 py-2 bg-Labels-Primary rounded-md outline outline-1 outline-yellow-500 inline-flex justify-center items-center gap-2 overflow-hidden"
                  icon={
                    <div className="w-4 h-4 flex justify-center items-center">
                      <PayrollImportOutlined />
                    </div>
                  }
                >
                  <span className="text-yellow-500 text-sm font-medium font-['Inter'] leading-normal">
                    Create
                  </span>
                </Button>
              )}
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}
